import React from 'react';
import {
  HeroContainer,
  HeroContent,
  HeroMain,
  HeroEyebrow,
  HeroH1,
  HeroP,
  HeroAside,
  HeroAsideLabel,
  HeroAsideList,
  HeroAsideStat,
  Band,
  BandInner,
  BandEyebrow,
  BandHeading,
  BandHeader,
  ArrowLink,
} from './HeroElements';
import EmailGrab from './EmailGrab';
import PullQuote from './PullQuote';
import HomePageGrid from './HomePageGrid';
import TeamStrip from './TeamStrip';

import { sectorsFrom } from '../../data/sectors';

/**
 * One responsive tree for every viewport. The previous version swapped in a
 * separate mobile hero above/below 800px, which meant two designs to keep in
 * sync — and the mobile branch carried a fixed-position clock that floated
 * over the portfolio grid.
 */
export default function Hero({ Projects }) {
  const sectors = sectorsFrom(Projects);

  return (
    <>
      <HeroContainer id="/">
        <HeroContent>
          <HeroMain>
            <HeroEyebrow>Miami, Florida</HeroEyebrow>
            <HeroH1>We back enduring consumer brands.</HeroH1>
            <HeroP>
              Patient capital for founders building category-defining products with craft,
              focus, and long-term ambition.
            </HeroP>
          </HeroMain>

          <HeroAside>
            <HeroAsideLabel>Where we invest</HeroAsideLabel>
            <HeroAsideList>
              {sectors.map(({ label }) => (
                <li key={label}>{label}</li>
              ))}
            </HeroAsideList>
            <HeroAsideStat>
              <strong>{(Projects || []).length}</strong>
              <span>Portfolio companies</span>
            </HeroAsideStat>
          </HeroAside>
        </HeroContent>
      </HeroContainer>

      <Band>
        <BandInner>
          <BandHeader>
            <div>
              <BandEyebrow>Portfolio</BandEyebrow>
              <BandHeading>Say hello to our companies.</BandHeading>
            </div>
            <ArrowLink href="/projects">See all companies</ArrowLink>
          </BandHeader>
          <HomePageGrid Projects={Projects} />
        </BandInner>
      </Band>

      <PullQuote />

      <Band>
        <BandInner>
          <BandHeader>
            <div>
              <BandEyebrow>People</BandEyebrow>
              <BandHeading>We're in this together.</BandHeading>
            </div>
            <ArrowLink href="/team">Meet the team</ArrowLink>
          </BandHeader>
          <TeamStrip />
        </BandInner>
      </Band>

      <EmailGrab />
    </>
  );
}
